import { merge } from 'lodash';

import memoizePromise from '../../01-helpers/utilities/memoize-promise';
import { post } from '../../01-helpers/services/ajax';
import { publish } from '../../01-helpers/event-manager';

import { FILTERAPI_FAILED } from '../../02-const/event-names';

/* ========================================================================== */

const defaultParams = {};

export default memoizePromise(data => new Promise((resolve, reject) => {
    post(
        '/umbraco/api/overviewfilter/filter',
        {
            // add data to api call
            data: JSON.stringify(merge({}, defaultParams, data)),
            contentType: 'application/json'
        }
    )
        .done(data => resolve(data))
        .fail((response) => {
            let message = '';
            switch (response.status) {
                case 0:
                    message = response.statusText;
                    break;
                default:
                    message = response.responseJSON.Message || 'Er is een fout opgetreden. Probeer het later nogmaals.'
                    break;
            }
            publish(FILTERAPI_FAILED, { 'message': message });
        });
}));
